import axios from "axios";
import { ALT_DOMAIN_ID, API_HOST } from "@/core/variables";
import { EntityValueCreate, EntityValueUpdate } from "@/model";

class EntityValueRepository {
    deleteMany = async (agentId: number, entityId: string, ids?: string[], keyword?: string) => {
        const params = new URLSearchParams();
        ids?.forEach((id) => params.append("ids", `${id}`));
        if (keyword)
            params.append("keyword", keyword);

        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities/${entityId}/values`, {
                params: params
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };


    find = async (
        agentId: number,
        entityId: string,
        page: number,
        size: number,
        keyword?: string
    ) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities/${entityId}/values`, {
            params: {
                keyword: keyword,
                page: page,
                size: size
            }
        });
    };

    create = async (
        agentId: number,
        entityId: string,
        form: EntityValueCreate
    ) => {
        return axios.post(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities/${entityId}/values`, {
            ...form
        });
    };

    update = async (
        agentId: number,
        entityId: string,
        entityValueId: string,
        form: EntityValueUpdate
    ) => {
        return axios.put(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities/${entityId}/values/${entityValueId}`, {
            ...form
        });
    };
}

const entityValueRepository = new EntityValueRepository();
export default entityValueRepository;
